import { render, staticRenderFns } from "./ExternalLinkHandler.vue?vue&type=template&id=62804c79"
import script from "./ExternalLinkHandler.vue?vue&type=script&lang=js"
export * from "./ExternalLinkHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports